import React from 'react';
import Draggable from 'react-draggable';
import {connect} from 'react-redux';
import {closeModal} from '../../../Redux/actions/ui.js';
import Inventum from '../../../../engine/Inventum';

let CloseButton = (props) => {
  return (
    <div onClick={props.handleClick} className="titlebarCloseButton"><i className="material-icons notranslate">close</i></div>
  )
}

let MinimizeButton = (props) => {
  return (
    <div className="titlebarMinMaxButton" onClick={props.toggleMinimize}>
      <i className="material-icons notranslate">{props.minimized ? "crop_square" : "remove"}</i>
    </div>
  )
}

function WindowControls(props) {
  return (
    <div className="windowControlsContainer">
      <MinimizeButton minimized={props.minimized} toggleMinimize={props.toggleMinimize} />
      <CloseButton handleClick={props.handleClose} />
    </div>
  )
}

let Content2D = (props) => {
  return (
    <div className='helpModal'>
      <div className='helpSection'>
        <h2 className='helpTitle'>Inventum 3D</h2>
        <p className='helpDescription'>Inventum3D is a powerful way to visualise 3D data in your web browser.</p>
        <p className='helpDescription'>
          For more information visit{" "}
          <a href="https://www.Inventum3d.com/about" target="_blank" rel="noopener noreferrer">
            Inventum3d.com/about
          </a>
        </p>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Map Controls</h3>
        <ul className='helpList'>
          <li><strong>Left Click + Drag</strong> — Pan map</li>
          <li><strong>Scroll Wheel</strong> — Zoom in/out</li>
          <li><strong>Click Marker</strong> — View project in 3D</li>
        </ul>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Keyboard Shortcuts</h3>
        <ul className='helpList'>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>S</kbd> — Open Search/Admin</li>
        </ul>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Usage Tips</h3>
        <ul className='helpList'>
          <li>Click on a map marker to view the project in 3D</li>
          <li>Black markers are using a legacy version of Inventum3D</li>
          <li>Add map layers using the panel in the bottom of the sidebar</li>
          <li>Drag layer handles to change their display order</li>
        </ul>
      </div>
    </div>
  );
}

let Content3D = (props) => {
  return (
    <div className="helpModal">
      <div className='helpSection'>
        <h2 className='helpTitle'>Inventum 3D</h2>
        <p className='helpDescription'>Inventum3D is a powerful way to visualise 3D data in your web browser.</p>
        <p className='helpDescription'>
          For more information visit{" "}
          <a href="https://www.Inventum3d.com/about" target="_blank" rel="noopener noreferrer">
            Inventum3d.com/about
          </a>
        </p>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Mouse Controls</h3>
        <ul className='helpList'>
          <li><strong>Left Click + Drag</strong> — Orbit camera</li>
          <li><strong>Right Click + Drag</strong> — Pan camera</li>
          <li><strong>Scroll Wheel</strong> — Zoom in/out</li>
        </ul>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Keyboard Shortcuts</h3>
        <ul className='helpList'>
          <li><kbd>W</kbd> — Transform mode</li>
          <li><kbd>R</kbd> — Rotate mode</li>
          <li><kbd>E</kbd> — Scale mode</li>
          <li><kbd>Esc</kbd> — Hide active label transform gizmo</li>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>C</kbd> — Set active action camera</li>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>T</kbd> — Set active action state</li>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>U</kbd> — Update active action camera and state</li>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>S</kbd> — Toggle grid/sky visibility</li>
          <li><kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>H</kbd> — Hide UI (for recording)</li>
        </ul>
      </div>

      <div className='helpSection'>
        <h3 className='helpSectionTitle'>Tips</h3>
        <ul className='helpList'>
          <li>Toggle object visibility in the sidebar menu</li>
          <li>Press <kbd>Alt</kbd>/<kbd>Option</kbd> + <kbd>S</kbd> twice to alpha the background</li>
        </ul>
      </div>
    </div>
  );
}

let HelpContent = (props) => {
  return (
    <div className="LabelsPanel">
      <div className="EditorTabHeader">
        <div className="EditorTabTitle">
          <i className="material-icons notranslate">help</i>
          <span>Help</span>
        </div>
      </div>
      <div className="LabelDrawCollection">
        <div className="HelpContent">
          {props.viewerMode === "2D" ? <Content2D /> : <Content3D /> }
        </div>
      </div>
    </div>
  )
}

class HelpInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {title:"Help"}
    this.setTitle = this.setTitle.bind(this);
    this.toggleMinimize = this.toggleMinimize.bind(this);
  }

  toggleMinimize(force) {
    if (typeof(force) === "boolean") {
      this.setState({minimized:force});
    } else {
      this.setState({minimized:!this.state.minimized});
    }
  }

  setTitle(newTitle) {
    this.setState({title:newTitle})
  }

  render () {
    return (
      <Draggable handle=".popupDragHandle">
      <div className={"WorldEditorContainer" + (this.state.minimized ? " minimized" : "")}>
        <div className="popupDragHandle"><div style={{paddingLeft:"5px"}}>{this.state.title}</div><WindowControls minimized={this.state.minimized} toggleMinimize={this.toggleMinimize} handleClose={this.props.closeModal} /></div>
          {this.state.minimized ? null : <HelpContent viewerMode={this.props.viewerMode}/>}
        </div>
      </Draggable>
    )
  }
}

let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  }
})


let mapStateToProps = (state) => ({
  viewerMode: state.sidebarUI.mode,
})

const HelpInfoContainer = connect(mapStateToProps,mapDispatchToProps)(HelpContent)

export default HelpInfoContainer
